var getBuiltIn = require('../internals/get-built-in');

module.exports = getBuiltIn('document', 'documentElement');



//////////////////
// WEBPACK FOOTER
// ./~/handsontable/~/core-js/internals/html.js
// module id = x7Ba
// module chunks = 0